import { API, authClient } from "../index";

export const getIVAs = (accessToken) => {
  return authClient(accessToken).get(`${API}/iva`);
};
